import Container from './styled/Container'

const Card = Container

export default Card
